module.exports = __webpack_public_path__ + "img/redeem_card.113008c5.png";